<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-cancel-topping`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M22 27.071l4 4V45a1 1 0 01-1 1h-2a1 1 0 01-1-1V27.071zM5.535.707l39.599 39.598a1 1 0 010 1.414l-1.415 1.414a1 1 0 01-1.414 0L2.707 3.536a1 1 0 010-1.415L4.121.707a1 1 0 011.414 0zm19.174 9.617l12.728 12.728a1 1 0 010 1.414l-1.415 1.414a.998.998 0 01-.782.29L21.344 12.273l1.95-1.95a1 1 0 011.415 0zm-10.436 9.02l2.829 2.828-3.707 3.708a1 1 0 01-1.414 0l-1.414-1.414a1 1 0 010-1.414l3.706-3.708zM35 2a1 1 0 011 1v2a1 1 0 01-1 1l-19.93-.001-3.066-3.067.003-.049A1 1 0 0113 2h22z"/></svg>
</template>
<script>

export default {
  name: 'IconCancelTopping',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
